import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { BlockArrows } from 'shared/ui/block-arrows'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import { DocumentsSection } from './components/documents-section'
import { UserInfoCard } from './components/user-info-card'
import s from './styles.module.scss'

const createIcon = (id: AllIcons) => (
  <AppIcon
    id={id}
    height={24}
    width={24}
    color="var(--link)"
  />
)

const ProfileNew = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const bookFasterItems = useMemo(
    () => [
      {
        key: 'close_circle',
        name: t('сlose_circlу'),
        icon: createIcon(AllIcons.GROUP),
      },
    ],
    [t],
  )

  const helpItems = useMemo(
    () => [
      {
        key: 'support',
        name: t('help_appeal'),
        icon: createIcon(AllIcons.CHAT_FEEDBACK_FILLED),
      },
      {
        key: 'offers',
        name: t('public_offer'),
        icon: createIcon(AllIcons.POLICY_FILLED),
      },
    ],
    [t],
  )

  const insuranceItems = [
    {
      key: 'insurance_vzr',
      name: t('insurance.travel'),
      icon: createIcon(AllIcons.TRAVEL_INSURANCE),
    },
    {
      isNew: true,
      key: 'esim',
      name: t('esim_title'),
      icon: createIcon(AllIcons.ESIM),
    },
  ]

  const onGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1)

      return
    }

    navigate(RoutingPaths.path())
  }

  const handleBookFasterClick = (key: string) => {
    if (key === 'close_circle') {
      navigate(RoutingPaths.closeCircle.path())
    }
  }

  const handleHelpClick = (key: string) => {
    const routes: Record<string, () => void> = {
      esim: () => navigate(RoutingPaths.esim.path()),
      insurance_vzr: () => navigate(RoutingPaths.insurance.path()),
      support: () => navigate(RoutingPaths.feedback.path()),
      offers: () => navigate(RoutingPaths.offers.path()),
    }

    routes[key]?.()
  }

  return (
    <div className="container">
      <div className={s.wrapper}>
        <HeaderGoBack
          buttonWhite
          variant="grey"
          title={t('profile')}
          onGoBack={onGoBack}
        />

        <UserInfoCard />

        <DocumentsSection />

        <BlockArrows
          title={t('for_travel')}
          listContent={insuranceItems}
          onClick={handleHelpClick}
        />

        <BlockArrows
          title={t('book_quickly')}
          listContent={bookFasterItems}
          onClick={handleBookFasterClick}
        />

        <BlockArrows
          title={t('help')}
          listContent={helpItems}
          onClick={handleHelpClick}
        />
      </div>
    </div>
  )
}

export default ProfileNew
